module.exports = __webpack_public_path__ + "static/img/product14.1ab5b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product14.png
// module id = JQsY
// module chunks = 1